import { renderIcon } from '../../SvgIcon.esm.js';

/******************************************************
 * This file was created by scripts/generate.js as part
 * of the build process. Do not edit this file directly.
 ******************************************************/
var iconType = {
  viewBox: "0 0 24 24",
  paths: [{
    d: "M2.1942 3.427c.3927-.3033.965-.2678 1.3158.083L20.49 20.5c.39.39.39 1.02 0 1.41l-.0942.083c-.3928.3047-.9658.277-1.3258-.083l-1.56-1.56c-1.88 1.25-4.2 1.87-6.69 1.59-4.54-.52-8.23-4.21-8.75-8.75-.29-2.49.34-4.82 1.59-6.7L2.1 4.93c-.39-.39-.39-1.03 0-1.42zM5.12 7.94C4.41 9.14 4 10.52 4 12c0 4.41 3.59 8 8 8 1.48 0 2.86-.41 4.05-1.12l-1.47-1.47c-.78.37-1.66.59-2.58.59-3.31 0-6-2.69-6-6 0-.92.22-1.8.59-2.59zM12 2c5.52 0 10 4.48 10 10 0 2.04-.61 3.93-1.67 5.5l-1.45-1.45C19.59 14.86 20 13.48 20 12c0-4.41-3.59-8-8-8-1.48 0-2.86.41-4.06 1.11L6.49 3.66C8.07 2.61 9.96 2 12 2zm0 4c3.31 0 6 2.69 6 6 0 .92-.22 1.8-.59 2.58L9.42 6.59C10.2 6.22 11.08 6 12 6z"
  }],
  circles: []
};
var MotionPhotosOffIcon = function MotionPhotosOffIcon(props) {
  return renderIcon(props, iconType);
};
export { MotionPhotosOffIcon };